<template>
	<div>
		<c-dialog ref="dialog" width="500" mask-close @close="dialogFormEditConfirm($refs.outputForm, arguments)" @resolve="editHandle">
			<c-form ref="outputForm" unit-width="100%">
				<c-form-item label="计价方式" required>
					<c-radio-group name="pricing_type" :options="pricingTypeDic" v-model="pricing_type" ></c-radio-group>
				</c-form-item>
				<c-form-item label="报工时长" v-show="pricing_type == 2" required>
					<c-grid-row gap column="2">
						<c-grid-col>
						<c-input type="stepper" stepControls="side" name="duration_hours" :range="[0,262800]" append-text="小时" v-model="duration_hours" @change="changeHoursMinutes" :clear="false"></c-input>
						</c-grid-col>
						<c-grid-col>
						<c-input type="stepper" stepControls="side" name="duration_minutes" :range="[0,59]" append-text="分钟" v-model="duration_minutes" @change="changeHoursMinutes" :clear="false"></c-input>
						</c-grid-col>
					</c-grid-row>
				</c-form-item>
				<c-form-item label="报工时间" v-show="pricing_type == 2" required>
					<c-datetime start-name="real_start_date" end-name="real_end_date" type="datetime" range time-accuracy="min" :clear="false" format="yyyy-MM-dd hh:mm" v-model="real_date" @change="changeRealDate"></c-datetime>
				</c-form-item>
				<c-form-item label="工资单价">
					<c-input type="number" name="price" decimal="6" :range="[0,99999999]" v-model="price" append-text="元"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
import {mapState} from "vuex";

export default {
	computed: {
		// 获取dictName选项数据
		...mapState(['pricingTypeDic'])
	},
	data() {
		return {
			duration_minutes:0,
			duration_hours:0,
			real_date:[],
			price:0,
			salary:0,
			pricing_type:1, //计价方式（1：计件，2：计时）
			output_ids:[]
		}
	},
	// 监听器
	watch: {
		
	},

	methods: {
		//输入报工时长小时、分钟
		changeHoursMinutes(){
			var currentTime = new Date(this.real_date[1]);
			var real_start_date = new Date(currentTime.getTime() - (this.duration_hours * 60 * 60 * 1000) - (this.duration_minutes * 60 * 1000)).format('yyyy-MM-dd hh:mm');
			var real_end_date = new Date(currentTime).format('yyyy-MM-dd hh:mm');
			this.real_date = [real_start_date, real_end_date];
		},
		
		//报工时间选择
		changeRealDate(data){
			const start = new Date(data[0]);
			const end = new Date(data[1]);
			const difference = end - start; // 时间差，单位毫秒
			// 转换为小时和分钟
			const hours = Math.floor(difference / 3600000);
			const minutes = Math.floor((difference % 3600000) / 60000)
			this.duration_hours = hours;
			this.duration_minutes = minutes;
		},
		
		/************打开新增/编辑报工弹窗**************/
		open(ids) {
			this.$refs.outputForm.clear();
			this.output_ids = ids;
			this.$refs.outputForm.set({
				real_start_date: new Date().format('yyyy-MM-dd hh:mm'),
				real_end_date: new Date().format('yyyy-MM-dd hh:mm'),
				duration_hours:0,
				duration_minutes:0,
				pricing_type: 1,
			});
			
			this.$refs.dialog.open({
				title: '批量编辑报工工资单价'
			});
		},
		
		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			this.$refs.outputForm.submit({
				url: '/output/editPrice/batch',
				rule: {
					price: '请输入报工工价',
					pricing_type:'请选择计价方式',
					duration_hours: '请输入报工时长',
					duration_minutes: '请输入报工时长',
				},
			    dataFormatter: data => {
					data.ids = this.output_ids;
					return data;
				},
				success: (data, res) => {
					next();
					let Mtype = 'success';
					let message = '成功' + res.success_count + '条';
					if(res.fail_count > 0 && res.success_count > 0){
						Mtype = 'warn';
						message += '，失败'+res.fail_count+'条';
					}else if(res.fail_count > 0 && res.success_count == 0){
						Mtype = 'fail'
						message += '，失败'+res.fail_count+'条';
					}else{
						message = '成功修改报工工资' + res.success_count + '条';
					}
					this.$message({
						message: message,  // 提示内容,
						type: Mtype
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		},
	}
}
</script>
<style lang="stylus" scoped>
</style>